import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creditNoteDetailsReportsList: { loading: false, data: null, error: null },
};

export const creditNoteDetailsReportSlice = createSlice({
  name: "creditNoteDetailsReports",
  initialState,
  reducers: {
    fetchCreditNoteDetailsReportsListRequest: (state, action) => {
      state.creditNoteDetailsReportsList.loading = true;
      state.creditNoteDetailsReportsList.error = null;
    },
    fetchCreditNoteDetailsReportsListSuccess: (state, action) => {
      state.creditNoteDetailsReportsList.data = action.payload;
      state.creditNoteDetailsReportsList.loading = false;
      state.creditNoteDetailsReportsList.error = null;
    },
    fetchCreditNoteDetailsReportsListFailure: (state, action) => {
      state.creditNoteDetailsReportsList.data = null;
      state.creditNoteDetailsReportsList.loading = false;
      state.creditNoteDetailsReportsList.error = action.payload;
    },
  },
});

export const {
  fetchCreditNoteDetailsReportsListRequest,
  fetchCreditNoteDetailsReportsListSuccess,
  fetchCreditNoteDetailsReportsListFailure,
} = creditNoteDetailsReportSlice.actions;

export const getCreditNoteDetailsReportsListState = (store) =>
  store.creditNoteDetailsReports?.creditNoteDetailsReportsList;

export default creditNoteDetailsReportSlice.reducer;
